import { FC } from "react";
import './loading.css'

export const Loading: FC<{
    showMsg?: boolean,
    extraMsg?: string,
    inline?: boolean
}> = ({ showMsg = false, extraMsg = "", inline = false }) => {
    return (
        <div className="loading-container">
            <div className="loading-bg"></div>
            <LoadingIcon showMsg={showMsg} extraMsg={extraMsg} inline={inline} />
        </div>
    )
}

export const LoadingIcon = (props: {
    showMsg: boolean,
    extraMsg: string,
    inline: boolean
}) => {
    return (
        <div className="loading-content" style={{ display: "content" }}>
            <i className="fa-duotone fa-spinner-third fa-5x fa-spin"></i>
            <span>
                {props.showMsg && <>
                    {props.extraMsg > "" && <><br />{props.extraMsg}, </>}please wait..
                </>}
            </span>
        </div>
    )
}

export default Loading;